module.exports = __webpack_public_path__ + "static/fonts/Fact-LightItalic.d80f591.ttf";